module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-20"
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('FilterPageList', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    ref: "pageListRef",
    attrs: {
      "get-data": _vm.getJobHistory,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters,
      "element-loading-text": "请稍等···"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          on: {
            "change": scope.search
          },
          model: {
            value: (_vm.filters.jobResult.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.jobResult, "value", $$v)
            },
            expression: "filters.jobResult.value"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "全部状态",
            "value": ""
          }
        }), _vm._v(" "), _vm._l((_vm.jobResults), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "fa fa-repeat"
          },
          on: {
            "click": function($event) {
              _vm.selectColumnChange();
              scope.search()
            }
          }
        }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          staticClass: "page-table",
          attrs: {
            "element-loading-text": "请稍等···"
          }
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("作业执行日志列表\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": scope.search
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table-header-separator"
        }), _vm._v(" "), _c('div', [(_vm.$common.hasPerm('job:batchRemove', _vm.domainName)) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchDelete()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash text-danger"
        }), _vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        })]), _vm._v(" "), _c('el-table', {
          ref: "multipleTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": _vm.JobHistoryList
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "topic",
            "label": "自定义参数",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.jobParameter) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "execTime",
            "label": "执行耗时 秒",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(scope.row.execTime) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "状态",
            "prop": "jobResult",
            "width": "90px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tag', {
                attrs: {
                  "type": scope.row.jobResult === true ? 'success' : 'warning',
                  "close-transition": ""
                }
              }, [_vm._v(_vm._s(_vm.translateJobResult[scope.row.jobResult]))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "作业执行时间",
            "prop": "createTime",
            "width": "160px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                                " + _vm._s(_vm._f("formatDate")(scope.row.createTime)) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobResultReason",
            "show-overflow-tooltip": "",
            "label": "失败原因"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" \n                                " + _vm._s(scope.row.jobResultReason) + "\n                            ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "120px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                attrs: {
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-delete text-danger"
                },
                on: {
                  "click": function($event) {
                    _vm.handleDelete(scope.row)
                  }
                }
              })], 1)]
            }
          }])
        })], 1)], 1)]
      }
    }])
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-862f1b0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_detail/job_history.vue
// module id = 1431
// module chunks = 1